import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/humenDoorKey/index',
    name: 'humenDoorKeyIndex',
    component: () => import('@/sub-app/humenDoorKey/pages/index.vue'),
    meta: {
      title: '智慧门禁',
      keepAlive: true,
    },
  },
  {
    path: '/humenDoorKey/faceProtocal',
    name: 'humenDoorKeyFaceProtocal',
    component: () => import('@/sub-app/humenDoorKey/pages/faceProtocal.vue'),
    meta: {
      title: '智慧门禁',
      keepAlive: false,
    },
  },
  {
    path: '/humenDoorKey/faceNotice',
    name: 'humenDoorKeyFaceNotice',
    component: () => import('@/sub-app/humenDoorKey/pages/faceNotice.vue'),
    meta: {
      title: '智慧门禁',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
